import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, changeDateFormat } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { thoke2Report } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';

const Thok2 = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [reportType, setReportType] = useState("");
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    // const token = useContext(MyContextProvider).token;
    // const decode_token = jwtDecode(token);

    const decode_token = getUserClaimsForUi();
    const token = decode_token
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };

    const config = getAuthHeaders();

    const storedLanguage = localStorage.getItem('language');

// Get next Year
const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
     return `${year}-${nextYear}`;
};


// Get Years
const getAllYears = () => {
    const yearsArray = [];
    let currentDate = new Date(); 
    let currentYear = currentDate.getFullYear();
   for (let year = currentYear; year >= 2001; year--) {
        yearsArray.push(year);
    }
    return yearsArray;
};

useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    setYears(getAllYears());
}, []);

const formatGrossValue = (value) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(2);
};


 
//Handle Button Click
const handleGenerateExcel = () => {
    if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
    }

    if (!reportType) {
        toast.error("Please select a Year Type", messages.COLOR_RED);
        return;
    }

  showLoading(true);
   const payload = {
        survey_year: yearName,
        report_type: reportType, 
    };
    
    axios
        .post(`${API_URL}api/price/prithok2`, payload, config)
        .then((response) => {
            const thok2 = response.data.data[0].GroupCodes;
            const payload = response.data.data[0].payload;
            const mappedData = [];
            if (!thok2 || thok2.length === 0) {
                toast.info("Data not found");
                showLoading(false);
                return;
            }
           
            thok2.forEach(group => {
                // Add group data
                mappedData.push({
                    name: group.majorGroupName,
                    bigdecimal1: formatGrossValue(group.majorGroupTotalPercentage),
                    bigdecimal2:'',
                    bigdecimal3:'',
                    bigdecimal4:'',
                    bigdecimal5:'',
                    bigdecimal6:'',
                    bigdecimal7:'',
                    bigdecimal8:'',
                    bigdecimal9:'',
                    bigdecimal10:'',
                    bigdecimal11:'',
                    bigdecimal12:'',
                    bigdecimal13:'',
                    bigdecimal14:formatGrossValue(group.majorGroupTotalweightedAvgTotal),
                    weightedAvg:''
                });
          
                group.subgroupsdata.forEach(subGroup => {
                  // Add subgroupsdata data
                  mappedData.push({
                    name: subGroup.field2,
                    bigdecimal1:formatGrossValue(subGroup.bigdecimal1),
                    bigdecimal2:formatGrossValue(subGroup.bigdecimal2),
                    bigdecimal3:formatGrossValue(subGroup.bigdecimal3),
                    bigdecimal4:formatGrossValue(subGroup.bigdecimal4),
                    bigdecimal5:formatGrossValue(subGroup.bigdecimal5),
                    bigdecimal6:formatGrossValue(subGroup.bigdecimal6),
                    bigdecimal7:formatGrossValue(subGroup.bigdecimal7),
                    bigdecimal8:formatGrossValue(subGroup.bigdecimal8),
                    bigdecimal9:formatGrossValue(subGroup.bigdecimal9),
                    bigdecimal10:formatGrossValue(subGroup.bigdecimal10),
                    bigdecimal11:formatGrossValue(subGroup.bigdecimal11),
                    bigdecimal12:formatGrossValue(subGroup.bigdecimal12),
                    bigdecimal13:formatGrossValue(subGroup.bigdecimal13),
                    bigdecimal14:formatGrossValue(subGroup.bigdecimal14),
                    weightedAvg:formatGrossValue(subGroup.weightedAvg),
                   });
              
                });
              });

             
            downloadReport(mappedData,parseInt(yearName),payload)
         })
        .catch((error) => {
            console.error('API Error:', error);
           
        }).finally(()=>{
            showLoading(false);
        });
};


//downLoad Excel sheet ****************
const downloadReport=(thok2,yearName,payload)=>{
   
    const excelObjectData = {
        fileName: `Thoke2_${yearName}`,
        fileType: 'xls',
        sheetName: "pri_lws_wages_unskilled",
        firstRowMergeCells: "A1:N1",
        firstRowExportDate: changeDateFormat(new Date()),
        secondRowText: ['कृषि से प्राप्त भाव  सूचकांक  - Thok2 (आधार वर्ष 2011-12=100)','','','','',''
            ,'','','','','','','',`${yearName}-${yearName+1}`,'',''],
        headerHindiColumns: ['जनपद','प्रतिशत','जुलाई','अगस्त','सितम्बर','अक्टूबर'
        ,'नवम्बर','दिसम्बर','जनवरी','फरवरी','मार्च', 'अप्रैल','मई','जून','औसत कृषि वर्ष','भारित औसत'],
       fourthRowText: ['','',`${yearName}`,`${yearName}`,`${yearName}`,`${yearName}`,
        `${yearName}`,`${yearName}`,`${yearName+1}`,`${yearName+1}`,`${yearName+1}`,
        `${yearName+1}`,`${yearName+1}`, `${yearName+1}`,'',`${yearName}-${yearName+1}`],
        number: ['1','2','3','4','5','6','7','8','9','10','11', '12','13','14','15','16'],
       boldcolumn:['Seed','Chemical Fertilizers','Repairs & Maintenance','Feed of livestock',
        'Irrigation Charges','Electricity','Pesticides & Insecticides','Diesel Oil','Depreciation'
    ,'Land revenue','Hired labour','TOTAL']
    };

    let transformedData = thok2.map(item => [
        item.name,
        item.bigdecimal1,
        item.bigdecimal2,
        item.bigdecimal3,
        item.bigdecimal4,
        item.bigdecimal5,
        item.bigdecimal6,
        item.bigdecimal7,
        item.bigdecimal8,
        item.bigdecimal9,
        item.bigdecimal10,
        item.bigdecimal11,
        item.bigdecimal12,
        item.bigdecimal13,
        item.bigdecimal14,
        item.weightedAvg, 
    ]);
let total=['TOTAL',`${payload.finalpercentagesum}`,'','','','','','','','','','','','','',`${payload.finalWeightsum}`]
transformedData[transformedData.length]=total;
    excelObjectData.excelRowData = transformedData;
    thoke2Report(excelObjectData);


}
    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.THOK2 : priceTitle.en.THOK2 }} />
                            </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">Select Year Type</label>
                                    <select
                                        name="reportType"
                                        className="form-select"
                                        onChange={(e)=>( setReportType(e.target.value))}
                                        value={reportType}
                                    >
                                        <option value="" disabled>[-Select-]</option>
                                        <option value="a">Agriculture Year</option>
                                  </select>
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                        Survey Year
                                    </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={(e)=>(setYearName(e.target.value))}
                                        value={yearName}
                                     >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years.map((ele, index) => (
                                            <option key={index} value={ele}>
                                                {getNextYear(ele)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default Thok2